<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.32596 1.02865C0.936799 2.40803 -0.0497516 5.17212 1.37562 7.64094C2.80099 10.1098 6.04181 13.7249 6.04181 13.7249L7.77219 12.7259C7.77219 12.7259 3.58113 7.46484 3.10601 6.6419C2.63088 5.81896 2.11323 3.92333 4.27621 2.67453C6.43919 1.42573 7.82204 2.82185 8.29716 3.64479C8.77229 4.46773 11.233 10.7278 11.233 10.7278L12.9633 9.72878C12.9633 9.72878 11.4529 5.11457 10.0275 2.64575C8.60217 0.176933 5.71513 -0.350734 3.32596 1.02865Z"
      fill="#A3B0BA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.16736 11.5154C5.18983 12.7744 6.04187 13.7249 6.04187 13.7249L7.77225 12.7259C7.77225 12.7259 6.94672 11.6896 5.98689 10.4649L4.16736 11.5154ZM10.1676 8.05112C10.7483 9.49469 11.233 10.7278 11.233 10.7278L12.9634 9.72874C12.9634 9.72874 12.5663 8.51562 11.9872 7.00061L10.1676 8.05112Z"
      fill="#ECEEF3"
    />
  </svg>
</template>